// Tenant content bundles (the `content.bundles` back-office setting's
// `bundlesAvailable` values). Canonical values per sj-admin TenantDetail.
export const CONTENT_BUNDLES = {
  AI_ACCESS: "ai_access",
  AI_ADVANTAGE: "ai_adv",
  ENTERPRISE: "enterprise",
} as const;

export type ContentBundle = (typeof CONTENT_BUNDLES)[keyof typeof CONTENT_BUNDLES];

// Bundles that mark a tenant as an AI tenant (vs enterprise / none).
export const AI_BUNDLES: ContentBundle[] = [
  CONTENT_BUNDLES.AI_ACCESS,
  CONTENT_BUNDLES.AI_ADVANTAGE,
];

// True when the tenant has any AI bundle available.
export const hasAiBundle = (bundles: readonly string[] | null | undefined): boolean =>
  (bundles ?? []).some(bundle => AI_BUNDLES.includes(bundle as ContentBundle));

export const isOnlyAiAccessBundle = (bundles: readonly string[] | null | undefined): boolean =>
  Array.isArray(bundles) && bundles.length === 1 && bundles[0] === CONTENT_BUNDLES.AI_ACCESS;
